import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApi.post("/api/hrchy-acl", params);
};

const getAllClsr = (params) => {
  return restApi.get("/api/hrchy-acl/clsr", { params });
};

const upsert = data => {
  return restApi.post("/api/hrchy-acl/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/hrchy-acl/${ids}`);
};

const hrchyAclService = {
  getAll,
  getAllClsr,
  upsert,
  remove
};

export default hrchyAclService;